export enum UserTypes {
  Collector = 'Collector',
  Creator = 'Creator',
  Company = 'Company'
}
